import * as moment from 'moment';
import * as React from "react";
import { connect } from "react-redux";
import { Button, Form, FormFeedback, Input, Label } from 'reactstrap';
import { bindActionCreators, Dispatch } from "redux";
import { authenticateUser as authenticateAction, signInFailure as signInFailureAction } from "../../actions/loginActions";
import { addNotification as addNotificationAction, clearNotifications as clearNotificationsAction } from "../../actions/notificationsActions";
import { UserService } from '../../services/user';
import MessageNotification from '../common/MessageNotification';
import Notification from '../common/Notification';

interface ILoginProps {
  addNotification: (notification: Notification) => any;
  clearNotifications: () => any;
  authenticateUser: (wsid: string, csrf: string, user: string) => any;
  signInFailure: () => any;
  userService?: UserService;
}

interface ILoginState {
  email: string;
  password: string;
  isInvalidEmail: boolean;
  isPasswordEmpty: boolean;
  lastSubmittedTime: number;
  lastSubmittedEmail: string;
  lastSubmittedPassword: string;
  lastSubmittedStatus: number;
}

export class Login extends React.Component<ILoginProps, ILoginState> {

  public userService: UserService;

  constructor(props: ILoginProps) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      email: '',
      password: '',
      isInvalidEmail: false,
      isPasswordEmpty: false,
      lastSubmittedTime: 0,
      lastSubmittedEmail: '',
      lastSubmittedPassword: '',
      lastSubmittedStatus: 200
    };
    this.userService = this.props.userService ? this.props.userService : new UserService();
  }

  public render() {
    const {isInvalidEmail, isPasswordEmpty} = this.state;
    return (
      <div>
        <MessageNotification />
        <div id="login" className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-sm-8 text-center">
              <h2> Quarantine Manager</h2>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-5 col-sm-8 col-xs-10 input-fields-container">
              <Form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <Label for="email">Email</Label>
                  <Input type="email" name="email" id="email" onChange={this.onEmailChange} invalid={isInvalidEmail} />
                  <FormFeedback>Please enter a valid Email</FormFeedback>
                </div>
                <div className="form-group">
                  <Label>Password</Label>
                  <Input type="password" name="password" id="password" onChange={this.onPasswordChange} invalid={isPasswordEmpty} />
                  <FormFeedback>Please enter your password</FormFeedback>
                </div>
                <div className="row justify-content-center">
                  <Button type="submit" className="col-sm-3 col-xs-6 btn btn-primary">Login</Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>);
  }

  public async handleSubmit(e?: React.FormEvent<HTMLFormElement>) {
    if (e) {
      e.preventDefault();
    }
    const { email, password, lastSubmittedTime, lastSubmittedEmail, lastSubmittedPassword, lastSubmittedStatus } = this.state;

    const isInvalidEmail = email === '' || !email.match(/^([A-Za-z0-9_\-.\"])+@([A-Za-z0-9_\-.])+\.([A-Za-z])+$/);
    const isPasswordEmpty = password.trim() === '';
    this.setState({ isInvalidEmail, isPasswordEmpty });

    if (!isInvalidEmail && !isPasswordEmpty) {
      // Prevent more than one login attempt per second
      if (moment().diff(lastSubmittedTime, 'seconds') < 1) {
        return;
      }
      // Prevent resubmitting the same credentials for bad login
      if (
        lastSubmittedStatus === 401 &&
        email === lastSubmittedEmail &&
        password === lastSubmittedPassword &&
        moment().diff(lastSubmittedTime, 'seconds') < 30
      ) {
        this.loginErrorMessage(401);
        return;
      }
      this.setState({
        lastSubmittedTime: moment.now(),
        lastSubmittedEmail: email,
        lastSubmittedPassword: password
      });
      try {
        const response = await this.userService.login(email, password);
        this.setState({ lastSubmittedStatus: response.status });

        if (response.ok) {
          const credentials = await response.json();
          if (credentials) {
            this.props.authenticateUser(credentials.wsid, credentials.csrf, email);
          }
        } else {
          this.props.signInFailure();
          this.loginErrorMessage(response.status);
        }
      } catch (e) {
        this.props.addNotification({ message: "Error while signing in. Please retry later.", isError: true });
        this.setState({ lastSubmittedStatus: 500 });
      }
    }
  }

  public componentDidMount() {
    this.props.clearNotifications();
  }

  private onEmailChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ email: e.currentTarget.value });
  }

  private onPasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ password: e.currentTarget.value });
  }

  private loginErrorMessage = (status?: number) => {
    let message;
    switch (status) {
      case 401:
        message = "Authorization failed.";
        break;
      case 404:
        message = "The Quarantine mailbox is not available.";
        break;
      case 429:
        message = "The Quarantine service is temporarily unavailable. Please try again later.";
        break;
      default:
        message = "The Quarantine service is not available.";
    }
    this.props.addNotification({ message, isError: true });
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    addNotification: bindActionCreators(addNotificationAction, dispatch),
    clearNotifications: bindActionCreators(clearNotificationsAction, dispatch),
    authenticateUser: bindActionCreators(authenticateAction, dispatch),
    signInFailure: bindActionCreators(signInFailureAction, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/login/Login.tsx